module.exports = {
  production: true,
  api: "https://api.mywater.janz.pt/v1/backoffice",
  amplify: {
    region: "eu-west-1",
    userPoolId: "eu-west-1_eGJbEeq0B",
    userPoolWebClientId: "ndfibcpc83v4juri069r0l4cd"
  }
};
  